import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { updateSubstationsAction, createSubstationsAction, substationModuleAction, getSubstationsAction } from "../action/subtationAction";


export const substationReducer = (
    builder: ActionReducerMapBuilder<{
        updateSubstationsConfig: any;
        createSubstationsConfig: any;
        substationModuleConfig: any
        getSubstationsConfig: any
    }>
) => {
    builder.addCase(updateSubstationsAction.fulfilled, (state, { payload }) => {
        state.updateSubstationsConfig = payload;
    });
    builder.addCase(createSubstationsAction.fulfilled, (state, { payload }) => {
        state.createSubstationsConfig = payload;
    });
    builder.addCase(substationModuleAction.fulfilled, (state, { payload }) => {
        state.substationModuleConfig = payload
    })
    builder.addCase(getSubstationsAction.fulfilled, (state, { payload }) => {
        state.getSubstationsConfig = payload
    })
};
